exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.border-left[data-v-b7874f04] {\n  border-left: 1px solid #9e9e9e;\n}\n.text-dots[data-v-b7874f04] {\n  -webkit-text-decoration: underline #9e9e9e dotted;\n          text-decoration: underline #9e9e9e dotted;\n}\n", ""]);

// exports
